export default __webpack_public_path__ + "static/media/plus.a05c538d.svg";